export default __webpack_public_path__ + "static/media/card-wireframe.8e6830c3.svg";